import {GetWithdrawalMembersRequest, PutWithdrawalMembersRequest, WithdrawalMember} from 'supporter';
import {api} from '@/api';
import {ActionContext} from 'vuex';

interface WithdrawMemberState {
  withdrawMembers: WithdrawalMember[];
  withdrawLen: number;
}

export default {
  namespaced: true,
  state: {
    withdrawMembers: null,
    withdrawtLen: 0
  },
  actions: {
    async fetchWithdrawMembers({commit}: ActionContext<WithdrawMemberState, any>, request: GetWithdrawalMembersRequest): Promise<any> {
      commit('SET_WITHDRAW_MEMBER', null);
      commit('SET_WITHDRAW_MEMBER_CNT', 0);

      api.getWithdrawalMembers(request).then((ret): void => {
        commit('SET_WITHDRAW_MEMBER', ret!.data!.contents);
        commit('SET_WITHDRAW_MEMBER_CNT', ret!.data!.totalCount);
      });
    },
    putWithdrawalMembers({commit}: ActionContext<WithdrawMemberState, any>, request: PutWithdrawalMembersRequest): Promise<void> {
      return api.putWithdrawalMembers(request).then((): void => {});
    }
  },
  mutations: {
    SET_WITHDRAW_MEMBER(state: WithdrawMemberState, members: WithdrawalMember[]): void {
      state.withdrawMembers = members;
    },
    SET_WITHDRAW_MEMBER_CNT(state: WithdrawMemberState, len: number): void {
      state.withdrawLen = len;
    }
  }
};
